export { default } from './FeedbackServiceService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/feedback/services/FeedbackService/index.js